import { render, staticRenderFns } from "./Saga2.vue?vue&type=template&id=6674aec2&scoped=true&"
import script from "./Saga2.vue?vue&type=script&lang=ts&"
export * from "./Saga2.vue?vue&type=script&lang=ts&"
import style0 from "./Saga2.vue?vue&type=style&index=0&id=6674aec2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674aec2",
  null
  
)

export default component.exports